import React, { useContext, useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { globalFileIcon } from "../../../axiosInstance";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { getProductsByCategory, setProducts } from "../../server/Product.js";
import { getAllCategory, getBySlug } from "../../server/Category";
import SubNavbar from "./SubNavbar.js";
import { reloedFunc } from "../../server/Product.js";

const formatCategoryName = (name) => {
  const lines = name.split("|");

  return (
    <span style={{ lineHeight: "1.2" }}>
      {lines.map((line, index) => (
        <span className="nowrap-text" key={index}>
          {line.trim()}
          {index < lines.length - 1 && <br />}
        </span>
      ))}
    </span>
  );
};

const NAVIGATOR = ({ currentSubCategory }) => {
  const { categories, toggleMenu, stationId, reloed } = useSelector((state) => ({
    categories: state.category.categories,
    toggleMenu: state.openCart.toggleMenu,
    stationId: state.user.stationId,
  }));
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [children, setChildren] = useState([]);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [activeSlug, setActiveSlug] = useState(null);      
  const [selectedSubSlug, setSelectedSubSlug] = useState(null); 
  const [reloedStart, setReloedStart] = useState(false);
  
    const currentAbortController = useRef(null);

  useEffect(() => {
    if (categories) dispatch(getAllCategory(stationId));
  }, [stationId]);

  useEffect(() => {
    if (pathname.startsWith("/category/")) {
      const slug = pathname.split("/")[2];
      setCurrentCategory(slug);
      setChildren(categories.find((cat) => cat.slug === slug)?.children || []);
      // handleCategoryClick(slug);
    } else {
      setCurrentCategory(null);
      setChildren([]);
    }
  }, [pathname, categories]);

  const handleCategoryClick = (slug) => {
    setActiveSlug(slug);       
    setSelectedSubSlug(null); 
    dispatch(setProducts([]));
    dispatch(reloedFunc());
    if (currentAbortController.current) {
      currentAbortController.current.abort();
    }
  
    const abortController = new AbortController();
    currentAbortController.current = abortController;
    setChildren([]);
    getBySlug(stationId, slug, { signal: abortController.signal })
      .then((res) => {
        if (!abortController.signal.aborted && !selectedSubSlug) {
          dispatch(setProducts(res));
        }
      })
      .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
      });
  
    navigate(`/category/${slug}`);
  };
  
  const handleSubCategoryClick = (slug) => {
    setSelectedSubSlug(slug);
    dispatch(setProducts([]));
    dispatch(reloedFunc());
    if (currentAbortController.current) {
      currentAbortController.current.abort();
    }
  
    const abortController = new AbortController();
    currentAbortController.current = abortController;
  
    getBySlug(stationId, slug, { signal: abortController.signal })
      .then((res) => {
        if (!abortController.signal.aborted) {
          dispatch(setProducts(res));
        }
      })
      .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
      });
  };
  

  return (
    <div className="navigator">
      <nav className={toggleMenu ? "active main" : "main"}>
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} RTL>
          <div className="item-sale">
            <img
              loading="lazy"
              src={globalFileIcon + "sale-icon.svg"}
              alt="sale"
            />
            <NavLink
              className={pathname === "/sales" ? "active" : null}
              to="/sales"
            >
              מבצעים
            </NavLink>
          </div>
          {categories &&
            categories.length > 0 &&
            categories.map((element, index) => (
              <div
                key={index}
                className={
                  element.slug === currentCategory ? "item-active" : "item"
                }
                onClick={() => handleCategoryClick(element.slug)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                >
                  {formatCategoryName(element.name)}
                </div>
              </div>
            ))}
        </ScrollMenu>
      </nav>
      {children.length !== 0 && (
        <SubNavbar
          fatherSlug={currentCategory}
          currentSubCategory={currentSubCategory}
          currentCategories={children}
          handleSubCategoryClick={handleSubCategoryClick}
        />
      )}
    </div>
  );
};

const RightArrow = () => {
  const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

  return (
    <button
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
      style={{ height: "60px" }}
    >
      <div className="right-btn">
        <img
          loading="lazy"
          src={globalFileIcon + "open-cart.svg"}
          alt="open-cart"
        />
      </div>
    </button>
  );
};

const LeftArrow = () => {
  const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);

  return (
    <button
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
      style={{ height: "60px" }}
    >
      <div className="left-btn">
        <img
          loading="lazy"
          src={globalFileIcon + "open-cart.svg"}
          alt="open-cart"
        />
      </div>
    </button>
  );
};

export default NAVIGATOR;
